<script>
import moment from 'moment'
import 'moment-timezone'
import { mixin as clickaway } from 'vue-clickaway'
import { formatThousands } from '@/utils/helpers'
import filtersField from '@/components/services/ui/filtersField.vue'
import {
  RexCheckboxesGroup,
  RexDistance,
  RexSlider,
  RexSelect
} from '@/components/views/rexFieldsV2'

export default {
  name: 'tours-filter',
  components: {
    filtersField,
    RexCheckboxesGroup,
    RexDistance,
    RexSlider,
    RexSelect
  },
  mixins: [
    clickaway
  ],
  data: () => ({
    quickFilterButton: {
      isShow: false,
      offsetTop: 0,
    }
  }),
  computed: {
    isLoading() {
      return this.$store.getters['toursSearch/isLoading']
        || this.$store.getters['toursSearch/isEmptySearchResults']
    },
    isDisabled() {
      return this.$store.getters['toursSearch/isFiltersDisabled']
    },
    collectionFilters() {
      return this.$store.getters['toursSearch/getCollectionFilters']
    },
    minPrices() {
      return this.$store.getters['toursSearch/getMinPrices']
    },
    isFiltersApplied() {
      return this.$store.getters['toursSearch/isFiltersApplied']
    },
    currencySign() {
      const dictionary = this.$store.getters.getDictionary('toursSearch.dictionaries.currencies')

      let sign = null

      if (dictionary.length) {
        const { currency } = this.$store.getters['toursSearch/getForm']

        sign = dictionary.find(item => item.slug === currency).sign
      }

      return sign
    }
  },
  methods: {
    filter() {
      this.hideQuickFilterButton()
      this.$emit('filter')
    },
    resetFilters() {
      this.$emit('reset')
    },
    formChangeHandler({ element }) {
      this.$store.commit('toursSearch/setIsFiltersApplied', false)

      this.quickFilterButton = {
        isShow: true,
        offsetTop: element.offsetTop
      }
    },
    durationFormatter(duration) {
      const time = moment.duration(duration * 1000)

      const minutes = time.minutes()
        ? time.minutes()
        : '00'

      return `${time.asHours().toFixed()}:${minutes}`
    },
    timeFormatter: time => moment.unix(time).utcOffset(0).format('HH:mm'),
    hideQuickFilterButton() {
      this.quickFilterButton = {
        isShow: false,
        offsetTop: 0
      }
    },
    getOptionsWithBadges(optionName) {
      return this.collectionFilters[optionName].map((item) => {
        const minPrices = this.minPrices[optionName]
        const { amount } = minPrices.find(minPrice => minPrice.slug === item.slug).price

        const badge = `от ${formatThousands(amount)} ${this.currencySign}`

        return {
          ...item,
          badge
        }
      })
    },
  }
}
</script>

<template>
  <div
    v-on-clickaway="hideQuickFilterButton"
    class="search-content__filters"
  >
    <div
      class="search-content__filters-content"
    >
      <b-button
        v-if="quickFilterButton.isShow"
        type="is-primary"
        :style="{
          'top':`${quickFilterButton.offsetTop}px`
        }"
        class="rex-button2 search-content__filters-quickfilter"
        @click="filter"
      >
        Применить
      </b-button>
      <div>
        <filters-field
          label="Регионы"
          :default-open="true"
          :is-loading="isLoading"
        >
          <rex-select
            name="filtersRegions"
            store-module="toursSearch"
            placeholder="Название региона"
            target="filters.regions"
            :options="collectionFilters.regions"
            :is-multiple="true"
            :is-tagged="true"
            :has-search="true"
            :is-disabled="isDisabled"
            @change="formChangeHandler"
          />
        </filters-field>
        <filters-field
          label="Звездность"
          :is-loading="isLoading"
        >
          <rex-checkboxes-group
            name="filtersCategory"
            store-module="toursSearch"
            target="filters.category"
            :options="getOptionsWithBadges('categories')"
            :default-show="7"
            :is-disabled="isDisabled"
            @change="formChangeHandler"
          />
        </filters-field>
        <filters-field
          label="Питание"
          :is-loading="isLoading"
        >
          <rex-checkboxes-group
            name="filtersMeals"
            store-module="toursSearch"
            target="filters.meals"
            :options="getOptionsWithBadges('meals')"
            :default-show="7"
            :is-disabled="isDisabled"
            @change="formChangeHandler"
          />
        </filters-field>
        <filters-field
          label="Цена"
          :default-open="true"
          :is-loading="isLoading"
        >
          <rex-slider
            store-module="toursSearch"
            target="filters"
            :target-fields="['priceFrom', 'priceTo']"
            :boundary-values="[
              collectionFilters.price.priceFrom,
              collectionFilters.price.priceTo
            ]"
            :values-suffix="currencySign"
            :disabled="isLoading || isDisabled"
            :is-disabled="isDisabled"
            @change="formChangeHandler"
          />
        </filters-field>
        <filters-field
          label="Рейтинг"
          :default-open="true"
          :is-loading="isLoading"
        >
          <rex-slider
            store-module="toursSearch"
            target="filters"
            :target-fields="['ratingFrom', 'ratingTo']"
            :is-disabled="isDisabled"
            @change="formChangeHandler"
          />
        </filters-field>
        <filters-field
          v-if="isLoading || collectionFilters.distance.maxDistance"
          label="Расстояние от центра"
          :is-loading="isLoading"
        >
          <rex-distance
            name="toursSearchDistance"
            store-module="toursSearch"
            target="filters.distanceTo"
            :max-value="collectionFilters.distance.maxDistance"
            :is-disabled="isDisabled"
            @change="formChangeHandler"
          />
        </filters-field>
        <filters-field
          v-if="isLoading || collectionFilters.hotelType.length"
          label="Тип размещения"
          :is-loading="isLoading"
        >
          <rex-checkboxes-group
            name="filtersHotelType"
            store-module="toursSearch"
            target="filters.facts"
            :options="collectionFilters.hotelType"
            :default-show="7"
            :is-disabled="isDisabled"
            @change="formChangeHandler"
          />
        </filters-field>
        <filters-field
          v-if="isLoading || collectionFilters.bestFor.length"
          label="Подходит для"
          :is-loading="isLoading"
        >
          <rex-checkboxes-group
            name="filtersBestFor"
            store-module="toursSearch"
            target="filters.bestFor"
            :options="collectionFilters.bestFor"
            :default-show="7"
            :is-disabled="isDisabled"
            @change="formChangeHandler"
          />
        </filters-field>
        <filters-field
          v-if="isLoading || collectionFilters.roomFacilities.length"
          label="Оборудование номера"
          :is-loading="isLoading"
        >
          <rex-checkboxes-group
            name="filtersRoomFacilities"
            store-module="toursSearch"
            target="filters.facts"
            :options="collectionFilters.roomFacilities"
            :default-show="7"
            :is-disabled="isDisabled"
            @change="formChangeHandler"
          />
        </filters-field>
        <filters-field
          v-if="isLoading || collectionFilters.facilities.length"
          label="Услуги отеля"
          :is-loading="isLoading"
        >
          <rex-checkboxes-group
            name="filtersFacilities"
            store-module="toursSearch"
            getter-name="getField"
            setter-name="setField"
            target="filters.facts"
            :options="collectionFilters.facilities"
            :default-show="7"
            :is-disabled="isDisabled"
            @change="formChangeHandler"
          />
        </filters-field>
        <filters-field
          v-if="isLoading || collectionFilters.beach.length"
          label="Пляж"
          :is-loading="isLoading"
        >
          <rex-checkboxes-group
            name="filtersBeach"
            store-module="toursSearch"
            target="filters.facts"
            :options="collectionFilters.beach"
            :default-show="7"
            :is-disabled="isDisabled"
            @change="formChangeHandler"
          />
        </filters-field>
        <filters-field
          v-if="isLoading || collectionFilters.sportEntertainment.length"
          label="Спорт"
          :is-loading="isLoading"
        >
          <rex-checkboxes-group
            name="filtersSportEntertainment"
            store-module="toursSearch"
            target="filters.facts"
            :options="collectionFilters.sportEntertainment"
            :default-show="7"
            :is-disabled="isDisabled"
            @change="formChangeHandler"
          />
        </filters-field>
      </div>
      <div class="search-content__filters-button-wrap">
        <b-button
          class="rex-button2"
          type="is-primary"
          expanded
          :disabled="isLoading || isDisabled"
          @click="filter"
        >
          Фильтровать
        </b-button>
        <button
          class="search-content__filters-reset-button"
          :disabled="isLoading || isDisabled"
          @click="resetFilters"
        >
          Сбросить фильтры
        </button>
      </div>
    </div>
  </div>
</template>